
import {
  RevButton,
  RevContainer,
  RevIllustration,
  RevStickyBar,
} from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { tw } from '@core/tailwind'
import { InstallmentPaymentPrice } from '@payment'

import { HIGHLIGHTED_PICKERS_VARIANTS } from '../HighlightedPickers/HighlightedPickers.constants'
import Model from '../Model'
import PriceWrapper from '../PriceWrapper'

import translations from './AddToCart.translations'

const POSITION_Y_STICKYBAR_DISPLAY = -100

const selectedHighlightedPickersTypeStyles = {
  [HIGHLIGHTED_PICKERS_VARIANTS.info]: tw`text-info`,
  [HIGHLIGHTED_PICKERS_VARIANTS.accent]: tw`text-accent`,
}

export default {
  components: {
    RevButton,
    RevContainer,
    RevIllustration,
    InstallmentPaymentPrice,
    Model,
    PriceWrapper,
    RevStickyBar,
  },

  props: {
    installmentMonthlyPaymentPlan: {
      type: Object,
      default: null,
    },
    isVatIncluded: {
      type: Boolean,
      required: false,
      default: false,
    },
    originalPrice: {
      type: Object,
      default: () => ({}),
    },
    price: {
      type: Object,
      required: true,
    },
    productImage: {
      type: Object,
      default: () => ({}),
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
    subTitle: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showBottomBar: false,
    }
  },

  computed: {
    ...mapGetters({
      experiments: 'flags/getExperiments',
    }),

    translations: () => translations,

    selectedHighlightedPickersLabel() {
      return this.selectedHighlightedPickers?.label
    },
    selectedHighlightedPickersLabelStyle() {
      return (
        selectedHighlightedPickersTypeStyles[
          this.selectedHighlightedPickers?.type
        ] || ''
      )
    },
    shouldDisplayInstallmentPaymentPrice() {
      return (
        this.installmentMonthlyPaymentPlan !== null &&
        this.experiments.splitPaymentWording === 'splitPaymentWordingDisplayed'
      )
    },
    shouldDisplaySelectedHighlightedPickersLabel() {
      return !this.shouldDisplayInstallmentPaymentPrice
    },
    monthlyPaymentPlan() {
      return this.installmentMonthlyPaymentPlan
    },
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    async addToCart() {
      this.$emit('cart')
    },
    handleScroll() {
      window.requestAnimationFrame(() => {
        const { desktopAddToCartCta } = this.$refs
        const desktopAddToCartCtaBottomScroll =
          desktopAddToCartCta.getBoundingClientRect().bottom

        // Show the sticky bar if the user scrolls past the add to cart button
        if (desktopAddToCartCtaBottomScroll <= POSITION_Y_STICKYBAR_DISPLAY) {
          this.showBottomBar = true
        }

        // Hide the sticky bar if the add to cart button is visible
        if (desktopAddToCartCtaBottomScroll > 0) {
          this.showBottomBar = false
        }
      })
    },
  },
}
